import { constants } from '../../constants';

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'stretch',
    },
    closeButtonStyle: {
        color: 'gray',
        backgroundColor: 'transparent',
        borderWidth: 0,
        fontSize: 30,
        position: 'absolute',
        top: 0,
        right: 0,
        borderRadius: 25
    },
    closeButtonTextStyle: {
        position: 'relative', 
        top: 0, 
        marginRight: 10, 
        fontFamily: 'Open Sans', 
        fontSize: 20, 
        fontWeight: '700',
        display: 'none'
    },
    modalOverlay: {
        backgroundColor: "rgba(0, 0, 0, 0.65)",
        zIndex:5,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        opacity: 1,
        WebkitTransition: 'all 1s',
    },
    modalContent: {
        display: 'flex',
        position: 'relative',
        justifyContent: 'flex-start',
        width: '400px',
        height: `auto`,
        top: "0px",
        left: "0px",
        right: "0px",
        bottom: "0px",
        border: "1px solid rgba(0,0,0,0.5)",
        background: "white",
        borderRadius: "5px",
        padding: "40px",
        zIndex: 6,
        // overflow: 'hidden',
        // paddingTop: 0,
        opacity: 1,
        WebkitTransition: 'all 1s',
    },
}

Object.freeze(styles);

export { styles as formModalStyles };


// WEBPACK FOOTER //
// ./src/js/components/FormModal/styles.js